import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINES = ["Identitetshantering", "byggd på decennier", "av erfarenhet."];

export const Hero = () => {
  const reduce = useReducedMotion();

  const fade = (delay) =>
    reduce
      ? {}
      : {
          initial: { opacity: 0, y: 16 },
          animate: { opacity: 1, y: 0 },
          transition: { duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] },
        };

  return (
    <section className="relative overflow-hidden bg-white pb-20 pt-32 md:pb-28 md:pt-44">
      <div className="mx-auto max-w-6xl px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-y-10 lg:grid-cols-[1.72fr_1fr] lg:items-end lg:gap-x-12">
          <div>
            <motion.p className="eyebrow" {...fade(0.05)}>
              <span className="ic-triangle" aria-hidden="true" />
              Identity &amp; Access Management
            </motion.p>

            <h1
              aria-label="Identitetshantering byggd på decennier av erfarenhet."
              className="mt-8 font-display text-[1.9rem] font-normal leading-[1.08] tracking-[-0.02em] text-brand-ink min-[480px]:text-[2.6rem] sm:text-6xl xl:text-7xl"
            >
              {reduce
                ? LINES.join(" ")
                : LINES.map((line, i) => (
                    <span key={line} className="block overflow-hidden pb-[0.24em] -mb-[0.14em]">
                      <motion.span
                        className="block"
                        initial={{ y: "115%" }}
                        animate={{ y: 0 }}
                        transition={{ duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                      >
                        {line}
                      </motion.span>
                    </span>
                  ))}
            </h1>
          </div>

          <div className="lg:pb-2">
            <motion.p
              className="max-w-xl text-lg leading-relaxed text-brand-muted md:text-xl lg:max-w-none"
              {...fade(0.5)}
              data-testid="hero-ingress"
            >
              IC Identity hjälper organisationer att skapa säker och effektiv identitetshantering. Vi
              kombinerar decennier av IAM-erfarenhet med djup förståelse för verksamhet, teknik och
              säkerhet, med särskilt fokus på offentlig sektor.
            </motion.p>

            <motion.div
              className="mt-9 flex flex-col items-start gap-5 sm:flex-row sm:flex-wrap sm:items-center"
              {...fade(0.62)}
            >
              <button
                type="button"
                className="btn-primary group"
                onClick={() => scrollToId("kontakt")}
                data-testid="hero-cta"
              >
                Börja med ett samtal
                <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
              </button>
              <button
                type="button"
                className="btn-secondary group"
                onClick={() => scrollToId("tjanster")}
                data-testid="hero-secondary"
              >
                Se våra tjänster
                <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
              </button>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
